import { default as ky, type Options } from 'ky';
import { makeBinded } from '@/proxies';

type WithData<T> = {
  data: T;
};

class HttpService {
  protected http: typeof ky;

  constructor(
    config: Options = {
      timeout: 30000,
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    },
  ) {
    this.http = ky.create(config);
  }

  aGet<T>(url: string, options?: Options) {
    return this.http.get(url, options).json<WithData<T>>();
  }

  aGetText(url: string, options?: Options) {
    return this.http.get(url, options).text();
  }

  aGetWithoutData<T>(url: string, options?: Options) {
    return this.http.get(url, options).json<T>();
  }

  aPost<T>(url: string, options?: Options) {
    return this.http.post(url, options).json<WithData<T>>();
  }

  aDelete<T>(url: string, options?: Options) {
    return this.http.delete(url, options).json<WithData<T>>();
  }

  aDeleteText(url: string, options?: Options) {
    return this.http.delete(url, options).text();
  }

  aPatch<T>(url: string, options?: Options) {
    return this.http.patch(url, options).json<WithData<T>>();
  }

  aPatchText(url: string, options?: Options) {
    return this.http.patch(url, options).text();
  }

  aPut<T>(url: string, options?: Options) {
    return this.http.put(url, options).json<WithData<T>>();
  }

  aPutText(url: string, options?: Options) {
    return this.http.put(url, options).text();
  }

  aPostText(url: string, options?: Options) {
    return this.http.post(url, options).text();
  }
}

export const httpService = makeBinded(HttpService);
